import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

// create new reservation
export const newReservation = createAsyncThunk(
  "reservation/newReservation",
  async (
    { createReservInfo, userUpdateInfo, confirmSaveData }: any,
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.post(
        `new-reservation`,
        { createReservInfo, userUpdateInfo, confirmSaveData },
        {
          withCredentials: true,
        },
      );
      // if (!result.data.Success) {
      //   toast.error(result.data.Description, {
      //     position: toast.POSITION.TOP_RIGHT,
      //   });
      // }
      return result.data;
    } catch (error: any) {
      // toast.error(error.response.data.Description, {
      //   position: toast.POSITION.TOP_RIGHT,
      // });
      return rejectWithValue(error.response.data);
    }
  },
);

// get all user's reservation
export const getAllUserReservations = createAsyncThunk(
  "reservation/getAllUserReservations",
  async (
    {
      page,
      limit,
      status,
      parkingName,
      vehicle,
      startDate,
      endDate,
    }: {
      page?: number;
      limit?: number;
      status?: string;
      parkingName?: string;
      vehicle?: string;
      startDate?: string;
      endDate?: string;
    } = {},
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.get(`get-user-reservations`, {
        params: {
          page,
          limit,
          status,
          parkingName,
          vehicle,
          startDate,
          endDate,
          t: new Date().getTime(),
        },
        withCredentials: true,
      });
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// get reservation by id
export const getReservationById = createAsyncThunk(
  "reservation/getReservationById",
  async (reservationID: String | undefined, { rejectWithValue }) => {
    try {
      const result = await axios.get(`get-reservation/${reservationID}`, {
        withCredentials: true,
      });
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// cancel reservation
export const cancelReservation = createAsyncThunk(
  "reservation/cancelReservation",
  async (
    {
      reservationID,
      currentTime,
    }: { reservationID: String | undefined; currentTime: String | undefined },
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.put(
        `cancel-reservation/${reservationID}`,
        { currentTime },
        {
          withCredentials: true,
        },
      );
      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      toast.error(error.response.data.Description, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return rejectWithValue(error.response.data);
    }
  },
);

// delete reservation
export const deleteReservation = createAsyncThunk(
  "reservation/deleteReservation",
  async (reservationID: String | undefined, { rejectWithValue }) => {
    try {
      const result = await axios.put(`delete-reservation/${reservationID}`, {
        withCredentials: true,
      });
      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      toast.error(error.response.data.Description, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return rejectWithValue(error.response.data);
    }
  },
);

//
const reservationSlice = createSlice({
  name: "reservation",
  initialState: {
    reservation: {},
    reservations: [],
    exportedReservations: [],

    loading: false,
    errors: null,
    pagination: null,
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
  },
  reducers: {
    clearErrors: (state) => {
      state.errors = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // create new reservation
      .addCase(newReservation.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(newReservation.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.reservation = action.payload.Reservation;
      })
      .addCase(newReservation.rejected, (state: any, action: any) => {
        state.loading = false;
        state.errors = action.payload.Description;
      })
      // get all user's reservation
      .addCase(getAllUserReservations.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(getAllUserReservations.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.reservations = action.payload.Reservations;
        state.currentPage = action.payload.CurrentPage;
        state.totalPages = action.payload.TotalPages;
        state.totalCount = action.payload.TotalCount;
      })
      .addCase(getAllUserReservations.rejected, (state: any, action: any) => {
        state.loading = false;
        state.errors = action.payload.Description;
      })
      // get reservation by id
      .addCase(getReservationById.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(getReservationById.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.reservation = action.payload.Reservation;
      })
      .addCase(getReservationById.rejected, (state: any, action: any) => {
        state.loading = false;
        state.errors = action.payload.Description;
      })
      // cancel reservation
      .addCase(cancelReservation.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(cancelReservation.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.reservations = action.payload.Data;
      })
      .addCase(cancelReservation.rejected, (state: any, action: any) => {
        state.loading = false;
        state.errors = action.payload.Description;
      })
      // delete reservation
      .addCase(deleteReservation.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(deleteReservation.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.reservations = action.payload.Reservations;
      })
      .addCase(deleteReservation.rejected, (state: any, action: any) => {
        state.loading = false;
        state.errors = action.payload.Description;
      });
  },
});

export default reservationSlice.reducer;
